import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { DocIcon } from './icons/DocIcon';
import { ownReportPath } from '../reportAccess';
import { routesPath } from '../../../common/constants/routesPath';

// SC-QA-17: the report opened is not the user's; no sections, only a way to their own report or the dashboard
export const ReportUnavailable = ({ ownRecord }) => {
    const { t } = useTranslation('reportPage');
    const navigate = useNavigate();
    const type = ownRecord && t(`access.types.${ownRecord.type}`, { defaultValue: t('access.types.external') });

    return (
        <section className="card empty" aria-labelledby="access-title">
            <div className="empty-ic" aria-hidden="true">
                <DocIcon color="#B8165F" />
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8, maxWidth: 720 }}>
                <h2 id="access-title" className="h2">
                    {ownRecord ? t('access.otherTitle') : t('access.notFoundTitle')}
                </h2>
                <p style={{ margin: 0, fontSize: 15, lineHeight: 1.6, color: 'var(--tokens-text-secondary)' }}>
                    {ownRecord ? t('access.otherText', { type }) : t('access.notFoundText')}
                </p>
            </div>
            <div className="actions noprint">
                {ownRecord ? (
                    <button
                        type="button"
                        className="btn btn-primary"
                        onClick={() => navigate(ownReportPath(ownRecord), { state: { record: ownRecord } })}
                    >
                        {t('access.openOwn')}
                    </button>
                ) : (
                    <button
                        type="button"
                        className="btn btn-primary"
                        onClick={() => navigate(routesPath.ROOT.DASHBOARD)}
                    >
                        {t('access.dashboard')}
                    </button>
                )}
            </div>
        </section>
    );
};
